/**
 * parallax
 * @author PLEJ
 */

const parallax = (() => {
  const init = () => document.querySelectorAll("[data-parallax]").forEach(initItem);

  const initItem = (element) => {
    const obj = getObjProperties(element);

    onScroll(obj);
    window.addEventListener("scroll", () => onScroll(obj));
  };

  const getObjProperties = (element) => {
    return {
      element,
      windowHeight: window.innerHeight,
      elementHeight: element.offsetHeight,
      variant: element.getAttribute("data-parallax")
    };
  }

  const onScroll = (obj) => {
    const elementTop = obj.element.getBoundingClientRect().top;

    if (elementTop + obj.windowHeight <= obj.windowHeight && elementTop + obj.elementHeight + obj.windowHeight > obj.windowHeight) {
      obj.element.style.transform = getTranslate(obj, elementTop);
    } else if (elementTop + obj.windowHeight > obj.windowHeight) {
      obj.element.style.transform = `translate(0,0)`;
    }
  };

  const getTranslate = (obj, elementTop) => {
    const scrollTop = Math.abs(elementTop * 0.5);
    const direction = obj.variant.left || obj.variant.right ? "X" : "Y";
    const value = obj.variant.top || obj.variant.left ? -scrollTop : scrollTop;

    return `translate${direction}(${value}px)`;
  }

  return {
    init: init
  };
})();

export { parallax };
